<template>
	<div
		:id="chartsPieLineData.id"
		class="charts"
		:style="{ width: '100%', height: chartsPieLineData.height }"
		ref="echarts"
	></div>
</template>

<script>
//引入Echarts主模块
var echarts = require("echarts/lib/echarts");
//引入饼图
require("echarts/lib/chart/pie");
//引入折线图
require("echarts/lib/chart/line");
//引入提示框、标题组件、工具栏、缩放组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/toolbox");
require("echarts/lib/component/dataZoom");
export default {
	props: ["chartsPieLineData"],
	data() {
		return {};
	},
	mounted() {
		this.drawCharts();
	},
	methods: {
		drawCharts() {
			// 基于准备好的dom，初始化echarts实例
			// var myChart = echarts.init(document.getElementById(this.chartsPieLineData.id));
			var myChart = echarts.init(this.$refs.echarts);
			window.addEventListener("resize", () => {
				//echarts自适应宽度
				window.onresize = myChart.resize();
			});
			const colorList = this.chartsPieLineData.colorData; //顺序修改删除增加
			// 绘制图表
			myChart.setOption({
				color:this.chartsPieLineData.colorData,
        title: {
          text: this.chartsPieLineData.name,
          y: 0,
          x: 10,
          textStyle: {
            //文本样式
            color:"#606266",// 蓝色#295d99 橘色#b8573c
            fontWeight:400,
            fontSize: 14,
            lineHeight: 18
          }
        },
				legend: {
					top: "0",
					left: "center",
					textStyle: {
						color: "#000",
						fontSize: 13,
					},
					icon:"circle"
				},
				tooltip: {
					trigger: "axis",
					showContent: false,
					axisPointer: {
						type: "cross",
						label: {
							backgroundColor: "#6a7985",
						},
					},
				},
				toolbox: {
					//工具栏
					show: true,
					right: "1%",
					top: "0%",
					feature: {
						// dataView : {show: true, readOnly: false}, //数据视图工具
						// magicType: { show: true, type: ["line", "bar"] },//动态类型切换
						// restore: { show: true }, //配置项还原
						saveAsImage: {
							//保存为图片
							show: true,
							name: this.chartsPieLineData.name,
						},
					},
				},
				dataset: {
					source:this.chartsPieLineData.source
					// source: [
					// 	[
					// 		"product",
					// 		"2021-6",
					// 		"2021-7"
					// 	],
					// 	["整篇审查", 3, 30],
					// 	["条目审查", 1, 2],
					// 	// ["Cheese Cocoa", 40.1, 62.2, 69.5, 36.4, 45.2, 32.5],
					// 	// ["Walnut Brownie", 25.2, 37.1, 41.2, 18, 33.9, 49.1],
					// ],
				},
				xAxis: {
					type: "category",
					boundaryGap: false, //boundaryGap坐标轴两边的留白
					axisLine: {
						lineStyle: {
							type: "solid",
							color: "#bfbfbf", //x轴的颜色
							width: "1", //坐标线的宽度
						},
					},
					axisLabel: {
						//坐标轴刻度标签的相关设置
						textStyle: {
							color: "#4e452e", //坐标值得具体的颜色 蓝色#3d5470 橘色#4e452e
						},
						fontSize: 12, //x轴文字大小
						// rotate: "-30", //此处控制文字倾斜方向
						// formatter:function(value){ //文字过长省略显示
						//   return (value.length>10?(value.slice(0,10)+"..."):value);
						// }
						// formatter:'{value}篇'
					},
				},
				yAxis: { 
					gridIndex: 0 ,
					axisLine: {
						lineStyle: {
						type: "solid",
						color: "#bfbfbf", //x轴的颜色
						width: "1" //坐标线的宽度
						}
					},
					axisLabel: {
						textStyle: {
						color: "#1f273f",
						}
          	}
				},
				grid: {
					//图表位置
					top: "55%",
					right: "8%",
					left: "9%",
					bottom: this.chartsPieLineData.bottom,
				},
				series: [
					{
						type: "line",
						smooth: true,
						seriesLayoutBy: "row",
						showSymbol: true,
						emphasis: { focus: "series" },
						areaStyle: {
							opacity: 0.8,
							color: colorList[0], //区域颜色
						},
						itemStyle: {
							color: colorList[0], //折线点的颜色
							normal: {
								lineStyle: {
									color: colorList[0], //折线的颜色
								},
							},
						},
					},
					{
						type: "line",
						smooth: true,
						seriesLayoutBy: "row",
						showSymbol: true,
						emphasis: { focus: "series" },
						areaStyle: {
							opacity: 0.8,
							color: colorList[1],
						},
						itemStyle: {
							normal: {
								color: colorList[1],
								lineStyle: {
									color: colorList[1],
								},
							},
						},
					},
					{
						type: "pie",
						id: "pie",
						radius: "24%",
						center: ["50%", "25%"],
						emphasis: { focus: "series" },
						label: {
							// formatter: "{b}: \n {@`this.chartsPieLineData.source[0][1]`} ({d}%)",
							rich: {
								a: {
									padding: [0, 0, 0, 10],
									fontSize: 14,
									// align:"center",
									// color: '#000',
								},
								b: {
									padding: [0, 10, 0, 0],
									fontSize: 14,
								},
								hr: {
									width: "100%",
									height: 0,
									align: "center",
								},
								d: {
									color: "#000",
									fontSize: 30,
								},
							},
						},
						encode: {
							itemName: this.chartsPieLineData.source[0][0],
							value: this.chartsPieLineData.source[0][1],
							tooltip: this.chartsPieLineData.source[0][1],
						},
						itemStyle: {
							color: (params) => {
								return colorList[params.dataIndex];
							},
						},
					},
				],
			});

			//联动
			myChart.on("updateAxisPointer", function (event) {
				var xAxisInfo = event.axesInfo[0];
				if (xAxisInfo) {
					var dimension = xAxisInfo.value + 1;
					myChart.setOption({
						series: {
							id: "pie",
							label: {
								formatter: '{b}: \n {@[' + dimension + ']} ({d}%)',
							},
							encode: {
								value: dimension,
								tooltip: dimension,
							},
						},
					});
				}
			});

			//点击图表跳转
			// myChart.off('click');
			// myChart.on('click',(params)=>{
			//   console.log(params)
			//   //dataIndex 数据索引值
			//   console.log(this.chartsPieLineData.path)
			//   var url=this.$router.resolve({
			//     path: this.chartsPieLineData.path,
			//     // query: { uuid: _this.uuid[params.dataIndex] }
			//     query: { id:this.chartsPieLineData.idNum[params.dataIndex]}
			//   });
			//   window.open(url.href,'_blank');
			// });
		}
	},
};
</script>
<style scoped>
</style>
